import { ApolloError } from '@apollo/client'
import { Form, Spacer, Button } from '@spritz-finance/ui'
import { useFormContext } from 'react-hook-form'
import { GraphQLErrorMessage } from '../../../../components/ErrorMessage/ErrorMessage'
import { Row } from '../../../../components/Layout/Row'
import { BillType } from '../../../../graphql/generated/graphql'
import { BillListItem } from './BillTypeListItem'

export interface AddAccountFormData {
    accountNumber: string
    billType: BillType | null
}

export const BillTypeSelector = ({ options }: { options: BillType[] }) => {
    return (
        <Form.Select<BillType>
            name="billType"
            options={options}
            optionValue={(option) => option}
            renderItem={(option) => <BillListItem type={option} />}
            renderLabel={(option) => option}
            overrideLabel
        />
    )
}

export const AddAccountForm = ({
    submitting,
    error,
    billTypeOptions,
    preselectedType,
}: {
    submitting: boolean
    preselectedType: boolean
    error?: ApolloError
    billTypeOptions: BillType[] | null
}) => {
    const { watch } = useFormContext<AddAccountFormData>()
    const number = watch('accountNumber')
    const hasBillTypeOptions = billTypeOptions && billTypeOptions.length > 1
    return (
        <>
            <div style={{ width: '100%' }}>
                <Form.Input name="accountNumber" placeholder="Enter account number" />
            </div>
            {!preselectedType && hasBillTypeOptions && (
                <BillTypeSelector options={billTypeOptions} />
            )}
            <Spacer height={16} />
            {error && <GraphQLErrorMessage error={error} />}
            <Spacer height={16} />

            <Row align="center">
                <Button.CTA
                    type="submit"
                    disabled={!number || number.length < 3}
                    loading={submitting}
                >
                    Add bill
                </Button.CTA>
            </Row>
        </>
    )
}
